module.exports = __webpack_public_path__ + "img/scotland-logo-icon.ea4b1ed8.png";